import React from 'react'

import { Box, Typography, TextField } from '@mui/material'
import { lineItemInputStyles } from '../../../../styles/classes/MobilePreviewClasses'

const LineItemInput = ({
  label,
  value,
  onChange,
  placeholder,
  required,
  disabled,
  customClasses,
  multiline,
  onBlur
}) => {
  const { classes } = lineItemInputStyles()
  return (
    <Box>
      {label && (
        <Box
          className={classes.labelContainer}
        >
          <Typography
            fontSize={'10px'}
            letterSpacing={'1px'}
            fontFamily={'Rubik'}
            fontWeight={'700'}
          >
            {required && <span className={classes.required}>*</span>}
            {label}
          </Typography>
        </Box>
      )}
      <TextField
        InputProps={{
          disableUnderline: true,
          fullWidth: true
        }}
        onBlur={onBlur}
        size='small'
        onChange={onChange}
        disabled={disabled}
        id="outlined-basic"
        variant="standard"
        value={value}
        placeholder={placeholder}
        hiddenLabel
        className={[classes.inputComponetStyle, customClasses ?? customClasses]}
        multiline={multiline}
        rows={multiline ? 2 : 1}
      />
    </Box>
  )
}

export default LineItemInput
